import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {AclModule} from './acl/acl.module';
import {SharedModule} from './shared.module';
import {BASE_CLIENT, BaseClient} from './client/base.client';
import {DA_STORE_USER} from './user/user.store.interface';
import {DA_STORE_TOKEN} from './token/istore.interface';
import {MemoryStore} from './token/memory.service';
import {MemoryUserStore} from './user/user.memory.service';
import {SelectContactsModule} from "./select-contacts/select-contacts.module";
import {LoadingModule} from './loading/loading.module';
import {EmptyModule} from "./empty/empty.module";
import {PageModule} from "./page/page.module";
import {UploadFileModule} from "./upload-file/upload-file.module";
import {ImgCropperModule} from "./img-cropper/img-cropper.module";
import {LocationModule} from "./location/location.module";
import {TreePickerModule} from "./tree-picker/tree-picker.module";
import {LayoutModule} from "./layout/layout.module";
import {YzFloatButtonModule} from "./float-button/float-button.module";
import {AiAssistantModule} from "./ai-assistant/ai-assistant.module";

const MODULES = [
  AclModule,
  SelectContactsModule,
  LoadingModule,
  EmptyModule,
  PageModule,
  UploadFileModule,
  LocationModule,
  ImgCropperModule,
  TreePickerModule,
  LayoutModule,
  YzFloatButtonModule,
  AiAssistantModule
];

@NgModule({
  declarations: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    ...MODULES,
    SharedModule
  ],
  exports: [
    ...MODULES
  ]
})
export class NgYunzaiMobileModule {
  public static forRoot(client: BaseClient): ModuleWithProviders {
    return {
      ngModule: NgYunzaiMobileModule,
      providers: [
        { provide: BASE_CLIENT, useValue: client },
        { provide: DA_STORE_USER, useClass: MemoryUserStore },
        { provide: DA_STORE_TOKEN, useClass: MemoryStore }
      ]
    };
  }
}
